import angular from 'angular';
import '../../shared.module';
import template from './custom-field-inputs.component.html';
import './custom-field-inputs.component.scss';
import { toValueOptions } from '../../helpers/select-options.helper';

const BOOLEAN_OPTIONS = [
  { value: 'true', label: 'Sim' },
  { value: 'false', label: 'Não' }
];

const INPUT_TYPES = {
  text: 'text',
  number: 'number',
  integer: 'number',
  currency: 'number',
  date: 'date',
  datetime: 'datetime-local'
};

class CustomFieldInputsController {
  constructor() {
    this.booleanOptions = BOOLEAN_OPTIONS;
    this.optionsByKey = {};
  }

  $onChanges(changes) {
    if (changes.fields) {
      this.optionsByKey = (this.fields || []).reduce(
        (options, field) => ({ ...options, [field.chave]: toValueOptions(field.opcoes) }),
        {}
      );
    }
  }

  $onInit() {
    this.values = this.values || {};
    this.errors = this.errors || {};
  }

  inputType(field) {
    return INPUT_TYPES[field.tipo];
  }

  label(field) {
    const suffix = field.tipo === 'currency' ? ' (R$)' : '';
    return `${field.rotulo}${suffix}${field.obrigatorio ? ' *' : ''}`;
  }

  errorOf(field) {
    return (this.errors || {})[`custom.${field.chave}`] || '';
  }
}

angular.module('app.shared').component('cpCustomFieldInputs', {
  bindings: {
    fields: '<',
    values: '<',
    errors: '<'
  },
  controller: CustomFieldInputsController,
  controllerAs: 'vm',
  template
});
